import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { Input } from 'antd';
import { isEmpty } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus } from '@fortawesome/free-solid-svg-icons';

import { RootState } from '@share/utils';
import { SearchSvg } from '@share/assets';
import { getAccounts, setAccountsKeyword, IAccountsState } from '@store/slices';
import { WhiteButton } from '@components';

import './style.scss';

interface IMapStateToProps {
  accountsStore: IAccountsState;
}

interface IMapDispatchToProps {
  getAccounts: (page?: number) => void;
  setAccountsKeyword: (keyword: string) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, WrappedComponentProps {}

interface IState {}

class AccountsSearchComponent extends React.Component<IProps, IState> {

  state = { keyword: '' };

  handleSearch = () => {
    if (!isEmpty(this.state.keyword)) {
      this.props.setAccountsKeyword(this.state.keyword);
      this.props.getAccounts();
    }
  }

  renderSearchButton = () => {
    return (
      <div className="accounts-search-button" onClick={this.handleSearch}>
        <SearchSvg />
      </div>
    );
  }

  clearKeywordFilter = (): void => {
    this.props.setAccountsKeyword(null);
    this.props.getAccounts();
    this.setState({ keyword: '' });
  }

  handleOnKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      this.handleSearch();
    }
  }

  renderClearButton = ():any => {
    if (!isEmpty(this.props.accountsStore.keyword)) {
      return (
        <WhiteButton onClick={this.clearKeywordFilter}>
          <FontAwesomeIcon icon={faMinus} />
        </WhiteButton>
      );
    }
    return null;
  }

  render(): React.ReactNode {
    const { intl } = this.props;

    return (
      <div className="accounts-search">
        <Input
          placeholder={intl.formatMessage({ id: 'search.accounts.by.keyword' })}
          suffix={this.renderSearchButton()}
          value={this.state.keyword}
          onChange={(e) => this.setState({ keyword: e.target.value })}
          onKeyPress={this.handleOnKeyPress}
        />
        {this.renderClearButton()}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    accountsStore: state.accountsStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getAccounts,
  setAccountsKeyword,
};

export const AccountsSearch = connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AccountsSearchComponent));
